export default {

  //系统基础
  PAGE_HOME_INDEX:'home_index',//首页
  PAGE_LOGIN:'login',//登录页'
  PAGE_REGISTER:'register',//注册
  PAGE_FORGET_PASSWORD:'forget_password',//忘记密码

  PAGE_DECLARE_PROCESS:'declare_process',//申报流程
  PAGE_MY_TASK:'my_task',//我的任务
  PAGE_PENDING_TASK:'pending_task',//待接受任务
  PAGE_PROCESSED_TASK:'processed_task',//需处理任务
  PAGE_MY_INFO:'my_info',//我的信息
  PAGE_EXPERT_APPLICATION:'expert_application',//专家申请
  PAGE_MY_APPLICATION:'my_application',//我的申请
  PAGE_ACTIVITY_REGISTRATION:'activity_registration',//活动报名
  PAGE_ACTIVITY_LIST:'active_list',//活动列表
  PAGE_ACTIVITY_ENROLMENT:'active_enrolment',//已报名
  PAGE_MESSAGE_LIST:'message_list',//消息列表
  PAGE_LOOK_MESSAGE:'look_message',//查看消息
  PAGE_FEEDBACK_APPEAL:'feedback_appeal',//反馈诉求
}












// WEBPACK FOOTER //
// ./src/constant/PageName.js